(function () {
  'use strict';

  // tfc.sso's run block calls Auth.validate() (see sso.module.js).
  // This is a separate module so tfc.sso's run doesn't have to be mocked for every test
  angular
      .module('tfc.sso.Auth')
      .provider('Auth', Auth)
      .config(config);

  // @ngInject
  function config($httpProvider, AuthProvider) {


  }

  // @ngInject
  function Auth() {
    var basePath = 'ui';
    var paths = {
      login : '/auth/login',
      logout : '/auth/logout',
      validate : '/auth/validate',
      resetPassword: '/auth/password/reset',
      forgotPassword: '/auth/password/forgot',
      recoverPassword: '/auth/password/recover',
      getEmailByPasswordToken : '/auth/password/token'
    };

    var _usingActiveDirectory = false;

    this.setBasePath = function (bp) {
      basePath = bp;
    };

    this.setPath = function (name, path) {
      paths[name] = path;
    };

    this.usingActiveDirectory = function () {
      _usingActiveDirectory = true
    };

    this.$get = function ($rootScope, $http, $log, $q, $state, $urlRouter, CookieJar, Toast) {
      var _authenticatedUser;
      var _isValid,
          _hasValidated;

      function initVars() {
        _authenticatedUser = null;
        _isValid = false;
        _hasValidated = false;
      }

      initVars();

      return {
        getUser : getUser,
        login : login,
        logout : logout,
        validate : validate,
        resetPassword : resetPassword,
        forgotPassword : forgotPassword,
        recoverPassword : recoverPassword,
        getEmailByPasswordToken : getEmailByPasswordToken,
        isAuthenticated : isAuthenticated,
        hasValidated : function () { return _hasValidated; },
        can : can,
        usingActiveDirectory : function () { return _usingActiveDirectory}
      };

      function getUser() {
        if (isAuthenticated()) {
          return _authenticatedUser;
        } else {
          return null;
        }
      }

      function login(credentials) {
        return $http.post(basePath + paths.login, credentials).then(function (response) {
          _authenticatedUser = response.data;
          _isValid = true;
          var expiration = getUser().passwordExpiration;
          var ttlMs = expiration - Date.now();
          var ttlDays = Math.floor(ttlMs / 1000 / 60 / 60 / 24);
          var when;
          // Give them 7 days of warning before it expires
          if (ttlDays <= 7) {
            when = new Date(expiration).toLocaleDateString(); // 'mm/dd/yyyy'
            Toast.warn('Your password will expire on ' + when + '. Please reset it');
          }
          if ($state.params.dest) {
            document.location.hash = $state.params.dest;
            $urlRouter.sync();
          } else {
            $rootScope.$broadcast('auth.login');
          }
        }, handleError);
      }

      function logout() {
        return $http.post(basePath + paths.logout).then(function () {
          initVars();
          $rootScope.$broadcast('auth.logout');
        });
      }

      function validate() {
        return $http.get(basePath + paths.validate).then(function (response) {
          _authenticatedUser = response.data;
          _isValid = true;
        }, function(response) {
          _isValid = false;
          if (response.status === 403) {
            // They're already logged in from somewhere else, but they can't access this app.
            Toast.error('You do not have permission to use this application');
          } else if (response.status === 401) {
            _authenticatedUser = null;
          } else if (response.status >= 500) {
            Toast.error('Something is wrong with the server. Please contact operations.');
          } else {
            Toast.error('Unexpected error. (code = ' + response.status + ')');
          }
        }).finally(function () {
          _hasValidated = true;
        });
      }

      function resetPassword(change) {
        change = _.pick(change, ['user', 'pass', 'newPass']);
        return $http.post(basePath + paths.resetPassword, change)
            .then(null, handleError);
      }

      function forgotPassword(email) {
        return $http.post(basePath + paths.forgotPassword, { email : email });
      }

      function recoverPassword(token, newPassword) {
        return $http.post(basePath + paths.recoverPassword, {
          token : token,
          newPassword : newPassword
        }).then(null, handleError);
      }

      function getEmailByPasswordToken(token) {
        return $http.get(basePath + paths.getEmailByPasswordToken, {
          params : { token : token }
        }).then(_.property('data'));
      }

      function handleError(response) {
        if (response.status === 400) {
          switch (_.get(response.data, '_type')) {
            case 'PasswordInsecure':
              Toast.error(response.data.message, { state : true });
              break;
            case 'PasswordUnchanged':
              Toast.error('You cannot use your current or ' +
                  response.data.recentPasswordCount + ' most recent passwords.', { state : true });
              break;
            default:
              Toast.error('Oops! Something went wrong.');
              break;
          }
        } else if (response.status === 401) {
          switch (_.get(response.data, '_type')) {
            case 'TooManyFailedLoginAttempts':
              Toast.error("You've failed to login too many times. Please try again later.");
              break;
            case 'MustResetPassword':
              var user = response.data.user;
              if (user.passwordExpiration < Date.now()) {
                Toast.warn('Your password has expired. Please change it.');
              }
              $state.go('passwordResetPublic', { email : user.email });
              break;
            default:
              Toast.warn('Invalid email or password', { state : true });
          }
        } else if (response.status >= 500) {
          // TODO: move to an interceptor
          Toast.error('Unexpected error', { state : true });
        }
        return $q.reject(response);
      }

      function isAuthenticated() {
        return _isValid && !!_authenticatedUser;
      }

      function can(permission) {
        var user = getUser();
        return !!user && -1 !== user.privileges.indexOf(permission);
      }
    };
  }

})();
